import { IFileEntity } from 'graphql/files/models';
import { ArrangerResultsTree } from 'graphql/models';
import { IParticipantEntity } from 'graphql/participants/models';
import { IStudyEntity } from 'graphql/studies/models';

export interface IBiospecimenResultTree {
  biospecimen: ArrangerResultsTree<IBiospecimenEntity>;
}

export enum Status {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
}

export interface IBiospecimenEntity {
  key?: string;
  id: string;
  fhir_id: string;
  status: Status;
  score: number;
  volume: number;
  volume_unit: string;
  container_id: string;
  age_at_biospecimen_collection: number;
  biospecimen_storage: string;
  study_id: string;
  study: IStudyEntity;
  laboratory_procedure: string;
  collection_sample_id: string;
  collection_sample_type: string;
  collection_fhir_id: string;
  parent_sample_id: string;
  parent_sample_type: string;
  external_sample_id: string;
  sample_id: string;
  sample_type: string;
  files: ArrangerResultsTree<IFileEntity>;
  nb_files: number;
  participant: IParticipantEntity;
  external_parent_sample_id: string;
  external_collection_sample_id: string;
  external_container_id: string;
}
